export enum ONBOARDING_CARD_ENUMERATION {
  CARD_TERMS_AND_CONDITIONS = 'terms',
  CARD_ERROR = 'card-error-widget',
  CARD_EXPLAIN = 'how-it-works',
}
